<div class="da">
  <span class="da-label">{{ label }}</span>

  <div class="da-file da-file--pending" *ngIf="pendingFile">
    <mat-icon class="da-file-ico">schedule</mat-icon>
    <span class="da-file-name" [title]="pendingFile.name">{{ displayName }}</span>
    <span class="da-pending-tag">uploads on save</span>
    <button type="button" class="da-act da-del" (click)="clearPending()" title="Remove" aria-label="Remove"><mat-icon>close</mat-icon></button>
  </div>

  <div class="da-file" [class.da-file--pending]="!doc.id" *ngIf="!pendingFile && doc">
    <mat-icon class="da-file-ico">{{ doc.id ? 'description' : 'check_circle' }}</mat-icon>

    <a *ngIf="doc.id" class="da-file-link" (click)="openPreview()" [title]="displayName">{{ displayName }}</a>
    <span *ngIf="!doc.id" class="da-file-name" [title]="displayName">{{ displayName }}</span>
    <span class="da-pending-tag" *ngIf="!doc.id">matched · uploads on import</span>

    <button type="button" class="da-act da-del" *ngIf="doc.id && !readonly" [disabled]="deleting"
            (click)="remove()" title="Remove" aria-label="Remove">
      <mat-icon>delete_outline</mat-icon>
    </button>
  </div>

  <ng-container *ngIf="!pendingFile && !doc">
    <label class="da-upload" *ngIf="!readonly" [class.da-disabled]="uploading">
      <mat-icon>upload_file</mat-icon>
      <span>{{ uploading ? 'Uploading…' : 'Choose file' }}</span>
      <input type="file" hidden (change)="onFileSelected($event)"
             [disabled]="uploading" accept=".pdf,.jpg,.jpeg,.png,.doc,.docx">
    </label>
    <span class="da-empty" *ngIf="readonly">—</span>
  </ng-container>

  <div class="da-preview-scrim" *ngIf="previewOpen" (click)="closePreview()">
    <div class="da-preview" (click)="$event.stopPropagation()">
      <div class="da-preview-head">
        <span class="da-preview-title" [title]="displayName">{{ displayName }}</span>
        <span class="da-preview-btn" role="button" tabindex="0" (click)="download()" (keydown.enter)="download()" title="Download"><mat-icon>download</mat-icon></span>
        <span class="da-preview-btn" role="button" tabindex="0" (click)="closePreview()" (keydown.enter)="closePreview()" title="Close"><mat-icon>close</mat-icon></span>
      </div>
      <div class="da-preview-body">
        <div class="da-preview-loading" *ngIf="previewLoading"><mat-icon class="da-spin">progress_activity</mat-icon></div>
        <img *ngIf="!previewLoading && previewIsImage" [src]="previewRawUrl" alt="preview">
        <iframe *ngIf="!previewLoading && previewIsPdf" [src]="previewSafeUrl" title="preview"></iframe>
        <div class="da-preview-other" *ngIf="!previewLoading && !previewIsImage && !previewIsPdf">
          <mat-icon>insert_drive_file</mat-icon>
          <p>Preview not available for this file type</p>
          <span class="da-preview-dl" role="button" tabindex="0" (click)="download()" (keydown.enter)="download()">Download to view</span>
        </div>
      </div>
    </div>
  </div>
</div>
